module.exports = __webpack_public_path__ + "img/historia2.473846b8.jpg";